import { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import UserContext from "../../../context/UserContext";
import api from "../../../AxiosConfig";
import {
  FaTachometerAlt,
  FaUsers,
  FaCreditCard,
  FaListAlt,
  FaSignOutAlt,
  FaTags,
} from "react-icons/fa";
import { useSidebar } from "../context/SidebarContext";

const Sidebar = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  //  const [isCollapsed, setIsCollapsed] = useState(true);
  const { isCollapsed, handleMouseEnterSidebar, handleMouseLeaveSidebar } = useSidebar();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      const response = await api.post("/logout", {}, { withCredentials: true });
      if (response.status === 200) {
        setUser(null);
        localStorage.removeItem("jwtToken");
        navigate("/login");
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div
      className={`fixed top-0 left-0 h-full bg-gray-800 text-white p-4 flex flex-col shadow-lg
        transition-all duration-300 ease-in-out
        ${isCollapsed ? "w-20" : "w-64"}`}
      onMouseEnter={handleMouseEnterSidebar}
      onMouseLeave={handleMouseLeaveSidebar}
    >
      <div
        className={`flex items-center mb-6 ${isCollapsed ? "justify-center" : "justify-start"
          }`}
      >
        <img
          src="https://console-d.com/logo.png"
          alt="Console-D Logo"
          className="h-10 w-10 object-contain"
        />
        {!isCollapsed && (
          <h2
            className="text-2xl font-bold text-gray-50 ml-3 whitespace-nowrap"
            style={{ fontFamily: "Red Hat Display" }}
          >
            CONSOLE-D
          </h2>
        )}
      </div>
      <nav className="flex-1 overflow-hidden">
        <ul>
          <li className="mb-2">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `flex items-center py-2.5 px-4 rounded-md transition duration-200
                ${isActive
                  ? "bg-[#eb5527] text-white"
                  : "hover:bg-gray-700 text-gray-300"
                }`
              }
              end
            >
              <FaTachometerAlt className={`${isCollapsed ? "mr-0" : "mr-3"} transition-all duration-300`} size={20} />
              <span className="whitespace-nowrap overflow-hidden text-ellipsis">
                {!isCollapsed && "Dashboard Overview"}
              </span>
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink
              to="/dashboard/user-management"
              className={({ isActive }) =>
                `flex items-center py-2.5 px-4 rounded-md transition duration-200
                ${isActive
                  ? "bg-[#eb5527] text-white"
                  : "hover:bg-gray-700 text-gray-300"
                }`
              }
            >
              <FaUsers className={`${isCollapsed ? "mr-0" : "mr-3"} transition-all duration-300`} size={20} />
              <span className="whitespace-nowrap overflow-hidden text-ellipsis">
                {!isCollapsed && "Users"}
              </span>
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink
              to="/dashboard/subscription-types"
              className={({ isActive }) =>
                `flex items-center py-2.5 px-4 rounded-md transition duration-200
                ${isActive
                  ? "bg-[#eb5527] text-white"
                  : "hover:bg-gray-700 text-gray-300"
                }`
              }
            >
              <FaTags className={`${isCollapsed ? "mr-0" : "mr-3"} transition-all duration-300`} size={20} />
              <span className="whitespace-nowrap overflow-hidden text-ellipsis">
                {!isCollapsed && "Subscription Types"}
              </span>
            </NavLink>
          </li>
          <li className="mb-2">
            <NavLink
              to="/dashboard/subscription-management"
              className={({ isActive }) =>
                `flex items-center py-2.5 px-4 rounded-md transition duration-200
                ${isActive
                  ? "bg-[#eb5527] text-white"
                  : "hover:bg-gray-700 text-gray-300"
                }`
              }
            >
              <FaCreditCard className={`${isCollapsed ? "mr-0" : "mr-3"} transition-all duration-300`} size={20} />
              <span className="whitespace-nowrap overflow-hidden text-ellipsis">
                {!isCollapsed && "Subscriptions"}
              </span>
            </NavLink>
          </li>
          <li className="hidden mb-2">
            <NavLink
              to="/dashboard/user-activities"
              className={({ isActive }) =>
                `flex items-center py-2.5 px-4 rounded-md transition duration-200
                ${isActive
                  ? "bg-[#eb5527] text-white"
                  : "hover:bg-gray-700 text-gray-300"
                }`
              }
            >
              <FaListAlt className={`${isCollapsed ? "mr-0" : "mr-3"} transition-all duration-300`} size={20} />
              <span className="whitespace-nowrap overflow-hidden text-ellipsis">
                {!isCollapsed && "User Activities"}
              </span>
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className="mt-auto pt-4 border-t border-gray-700">
        <button
          onClick={handleLogout}
          disabled={isLoggingOut}
          className={`w-full flex items-center justify-${isCollapsed ? 'center' : 'start'} py-2.5 px-4 rounded-md font-semibold transition duration-200 shadow-md ${isLoggingOut ? "bg-red-400 cursor-not-allowed" : "hover:bg-red-700"
            } text-white`}
        >
          <FaSignOutAlt className={`${isCollapsed ? "mr-0" : "mr-3"} transition-all duration-300`} size={20} />
          <span className="whitespace-nowrap overflow-hidden text-ellipsis">
            {!isCollapsed && (isLoggingOut ? "Logging out..." : "Logout")}
          </span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
